var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2270_307)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 57.5,
    r: 57.5,
    fill: "#FE6728"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0674 67.7978H64.9331V74.6634H58.0674V67.7978ZM58.0674 40.3351H64.9331V60.9321H58.0674V40.3351ZM61.4659 23.1709C42.5167 23.1709 27.1719 38.55 27.1719 57.4993C27.1719 76.4485 42.5167 91.8276 61.4659 91.8276C80.4495 91.8276 95.8286 76.4485 95.8286 57.4993C95.8286 38.55 80.4495 23.1709 61.4659 23.1709ZM61.5002 84.9619C46.3271 84.9619 34.0375 72.6724 34.0375 57.4993C34.0375 42.3261 46.3271 30.0366 61.5002 30.0366C76.6734 30.0366 88.9629 42.3261 88.9629 57.4993C88.9629 72.6724 76.6734 84.9619 61.5002 84.9619Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2270_307",
    x: 0,
    y: 0,
    width: 123,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2270_307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2270_307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.3881,
    height: 82.3881,
    fill: "white",
    transform: "translate(20.3062 16.3057)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.887087c50052d32d785407b6024732c1.svg";
export { ForwardRef as ReactComponent };